import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function WhyItDidntWorkSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-100px'
  });
  const reasons = [{
    title: "Traditional vlogging requires extroversion most people don't have",
    detail: "Not everyone is built to be on camera. And that's okay."
  }, {
    title: 'Standard YouTube courses ignore real-life constraints',
    detail: 'They assume you have unlimited time, money, and energy.'
  }, {
    title: 'Early faceless methods used boring stock footage & robotic voices',
    detail: 'Viewers could spot the low-quality content instantly.'
  }, {
    title: 'Searching for "your passion" instead of market-backed methods',
    detail: 'Months wasted on niches that will never monetize.'
  }];
  return <section ref={ref} className="relative w-full py-24 md:py-32 px-4 bg-bg-secondary" data-id="element-316">
      <div className="max-w-4xl mx-auto" data-id="element-317">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-318">
          <h2 className="text-3xl md:text-5xl font-bold text-white mb-4" data-id="element-319">
            Why What You Tried{' '}
            <span className="text-accent-cyan" data-id="element-320">Didn't Work</span>
          </h2>
          <p className="text-text-muted text-lg" data-id="element-321">
            It's not your fault. The old methods were designed to fail.
          </p>
        </motion.div>

        <div className="space-y-4" data-id="element-322">
          {reasons.map((reason, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -30
        }} animate={isInView ? {
          opacity: 1,
          x: 0
        } : {}} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="glass-card rounded-xl p-6 flex items-start gap-4" data-id="element-323">
              <XCircleIcon className="w-6 h-6 text-red-500 flex-shrink-0 mt-1" data-id="element-324" />
              <div data-id="element-325">
                <h3 className="text-lg font-semibold text-white mb-1" data-id="element-326">
                  {reason.title}
                </h3>
                <p className="text-text-muted text-sm" data-id="element-327">{reason.detail}</p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.5
      }} className="mt-12 text-center" data-id="element-328">
          <p className="text-xl text-text-light" data-id="element-329">
            Until now, there wasn't a system designed for{' '}
            <span className="text-accent-green font-semibold" data-id="element-330">real people</span>{' '}
            with{' '}
            <span className="text-accent-green font-semibold" data-id="element-331">
              real constraints
            </span>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}